<template>
    <div class="preparation-order-containers">
        <div v-if="errorsSending" class="row align-items-center">
            <div class="col-md-12">
                <errors-zone :errors="errorsSending"></errors-zone>
            </div>
        </div>
        <div v-if="errorsDeleting" class="row mb-3 align-items-center">
            <div class="col-md-12">
                <errors-zone :errors="errorsDeleting"></errors-zone>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <div class="h5 text-center">
                    <i class="fas fa-shopping-bag"></i>
                    Contenants
                </div>
                <div class="preparation-order-containers-input">
                    <table>
                        <template v-if="order.containers.length === 0">
                            <tr>
                                <td colspan="4" class="text-center font-italic">Aucun contenant</td>
                            </tr>
                        </template>
                        <template v-else>
                            <tr v-for="container in order.containers">
                                <td>
                                    {{ container.container.name }}
                                </td>
                                <td>
                                    {{ container.category.name }}
                                </td>
                                <td>
                                    {{ container.quantity }}
                                </td>
                                <td class="text-right pl-2">
                                    <button v-if="!readOnly && orderInPreparation" class="btn btn-outline-dark btn-sm" @click="removeContainer(container.id)" :disabled="sending || deleting">
                                        <i class="fas fa-times"></i>
                                    </button>
                                </td>
                            </tr>
                        </template>
                        <tr v-if="!readOnly && orderInPreparation">
                            <td>
                                <select class="form-control form-control-sm" v-model="containerType">
                                    <option></option>
                                    <option v-for="containerType in containersTypes" :value="containerType.id">{{ containerType.name }}</option>
                                </select>
                            </td>
                            <td>
                                <select class="form-control form-control-sm" v-model="containerCategory">
                                    <option></option>
                                    <option v-for="categoryAndProducts in productsByMainCategory" :value="categoryAndProducts.category.id">{{ categoryAndProducts.category.name }}</option>
                                </select>
                            </td>
                            <td>
                                <input class="form-control form-control-sm" type="text" inputmode="numeric" placeholder="Qté" v-model="containerQuantity">
                            </td>
                            <td class="text-right pl-2">
                                <button class="btn btn-dark btn-sm ml-1" @click="addContainer()" :disabled="sending || deleting">
                                    Ajouter
                                </button>
                            </td>
                        </tr>
                    </table>
                    <div v-if="!readOnly && orderInPreparation && order.customer.type === 'store'"
                        class="alert alert-warning p-1 text-center m-2">
                        <i class="fad fa-exclamation-triangle"></i>
                        Pour le pain des clients magasins, utiliser uniquement des caisses ajourées au fond (pour éviter l'humidité).
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ErrorsZone from "../ErrorsZone";

    import {orderInPreparation} from "../../orders-utils";

    import {usePostRequest} from "../compositions/axios/postRequest";
    import {useDeleteRequest} from "../compositions/axios/deleteRequest";

    export default {
        name: 'PreparationOrderContainers',

        components: {
            ErrorsZone,
        },

        props: {
            order: {
                type: Object,
                required: true,
            },
            containersTypes: {
                type: Array,
                required: true,
            },
            productsByMainCategory: {
                type: Array,
                required: true,
            },
            readOnly: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        setup() {
            const {
                deleting,
                deleted,
                errorsDeleting,
                doDelete,
            } = useDeleteRequest();

            const {
                loaded: sent,
                loading: sending,
                errors: errorsSending,
                post,
            } = usePostRequest();

            return {
                sent,
                sending,
                errorsSending,
                post,

                deleting,
                deleted,
                errorsDeleting,
                doDelete,
            };
        },


        data() {
            return {
                containerType: null,
                containerCategory: null,
                containerQuantity: null,
            };
        },

        methods: {
            postPayload() {
                return {
                    container: this.containerType,
                    category: this.containerCategory,
                    quantity: this.containerQuantity,
                };
            },

            async removeContainer(id) {
                if(confirm('Êtes-vous sûr de vouloir supprimer ce contenant ?')) {
                    const response = await this.doDelete('/espace-employes/commandes/preparation/commande/' + this.order.id + '/contenants/' + id);

                    this.$emit('errors', this.errorsDeleting);

                    if (!this.errorsDeleting) {
                        if (!this.$root.echoConnectedWihoutErrors) {
                            window.location.reload();
                        }
                    }
                }
            },

            async addContainer() {
                this.$emit('submitted');

                let payload = this.postPayload();
                const response = await this.post('/espace-employes/commandes/preparation/commande/' + this.order.id + '/contenants', payload);

                this.$emit('errors', this.errorsSending);

                if (!this.errorsSending) {
                    if (!this.$root.echoConnectedWihoutErrors) {
                        window.location.reload();
                    }
                }
            },
        },

        computed: {
            orderInPreparation,
        },
    }
</script>

<style lang="scss" scoped>
    .preparation-order-containers {
        .preparation-order-containers-input {
            table {
                width: 100%;
                padding: 20px;
            }

            tr {
                border-top: 1px solid #979797;
                border-bottom: 1px solid #979797;
            }
            tr:last-of-type {
                border-bottom: 0;
            }
            td {
                text-align: center;
                padding: 5px 5px;
                width: 43%;
            }
            td:nth-last-of-type(2) {
                width: 14%;
            }
            td:last-of-type {
                width: 0;
            }
        }
    }
</style>
